import { loginAuditEventsResponseSchema, type LoginAuditEvent } from '@emr/shared';

import { apiRequest } from './client.ts';

/**
 * The login/logout audit viewer's read surface (`server/src/audit/loginEventsRoutes.ts`,
 * requiring `audit:read`). No `limit` param wired from the UI yet — the server's own default
 * (`@emr/shared`'s `DEFAULT_LIST_LIMIT`, 100 most-recent events) is the whole view for now; a
 * pagination/load-more control is a real, separate follow-on once a practice's history outgrows one
 * page, not something this first pass needed.
 */
export async function listLoginAuditEvents(
  signal?: AbortSignal,
): Promise<readonly LoginAuditEvent[]> {
  const response = await apiRequest(
    '/api/audit/login-events',
    loginAuditEventsResponseSchema,
    signal === undefined ? {} : { signal },
  );
  return response.events;
}
